import fetchRequest from '../../helpers/fetchRequest';

export async function getAdvertisementLineData() {
    const url = '/advertisement-settings';
    const options = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    return fetchRequest(url, options);
  }